import { AccountComponent } from "@/features"

export const AccountPage = () => {
  return <AccountComponent />
}
